import React, { memo } from 'react';
import { StyledToolbarButton } from './Toolbar.Styles';
export var ToolbarButton = memo(function (_a) {
    var onToggle = _a.onToggle, style = _a.style, label = _a.label, active = _a.active, disabled = _a.disabled, blockBg = _a.blockBg;
    var _onToggle = function (e) {
        e.preventDefault();
        onToggle(style);
    };
    return (React.createElement(StyledToolbarButton, { onClick: _onToggle, isActive: active, disabled: disabled, bg: blockBg, type: "button" }, label));
});
